import { Box, Divider } from '@mui/material'
import { useSelector }  from 'react-redux'
import LockdownKPIDashboardKpiCard     from './LockdownKPIDashboardKpiCard'
import LockdownKPIDashboardTechFilters from './LockdownKPIDashboardTechFilters'

export default function LockdownKPIDashboardKpiGrid({ showMarks = true, gridRef = null }) {
	const { tech1, tech2, kpiSel, numCharts = 3 } = useSelector(s => s.filters)

	if (!tech1) return null

	const comparing = tech2 !== null
	const kpis1     = Array.from(kpiSel[tech1] ?? []).slice(0, numCharts)
	const kpis2     = tech2 ? Array.from(kpiSel[tech2] ?? []).slice(0, numCharts) : []

	const renderTechBlock = (tech, kpis) => (
		<Box key={tech} sx={{
			flex: '1 1 0',
			display: 'flex',
			flexDirection: 'column',
			minHeight: 0,
			gap: 1,
		}}>
			{/* key forces full remount when tech changes — triggers useEffect
			    inside TechFilters to reload filter options for the new tech */}
			<LockdownKPIDashboardTechFilters key={`filters-${tech}`} tech={tech} />

			<Box sx={{
				flex: 1,
				minHeight: 0,
				display: 'flex',
				flexDirection: 'column',
				gap: 1.5,
			}}>
				{kpis.map((kpiName, slot) => (
					<Box key={`${tech}-${slot}`} sx={{ flex: 1, minHeight: 0 }}>
						<LockdownKPIDashboardKpiCard
							tech={tech}
							kpiName={kpiName}
							slot={slot}
							showMarks={showMarks}
						/>
					</Box>
				))}
				{Array.from({ length: Math.max(0, numCharts - kpis.length) }).map((_, i) => (
					<Box key={`${tech}-empty-${i}`} sx={{
						flex: 1, border: '1px dashed', borderColor: 'divider', borderRadius: 3,
					}} />
				))}
			</Box>
		</Box>
	)

	return (
		<Box ref={gridRef} sx={{
			display: 'flex',
			flexDirection: 'row',
			gap: 1.5,
			height: '100%',
			minHeight: 0,
		}}>
			{renderTechBlock(tech1, kpis1)}
			{comparing && (
				<>
					<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
					{renderTechBlock(tech2, kpis2)}
				</>
			)}
		</Box>
	)
}